module.exports = __webpack_public_path__ + "static/img/a121.ef19b41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a121.jpg
// module id = kgmV
// module chunks = 0